export const version = "abstract-provider/5.6.0";
